import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from 'react'

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
}

export function Field({ label, id, className = '', ...props }: FieldProps) {
  const fieldId = id || props.name || label
  return (
    <label htmlFor={fieldId} className="block">
      <span className="mb-1.5 block text-sm font-semibold text-slate-700">{label}</span>
      <input
        id={fieldId}
        className={`w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-slate-900 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-500 ${className}`}
        {...props}
      />
    </label>
  )
}

interface AreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string
}

export function Area({ label, id, className = '', ...props }: AreaProps) {
  const fieldId = id || props.name || label
  return (
    <label htmlFor={fieldId} className="block">
      <span className="mb-1.5 block text-sm font-semibold text-slate-700">{label}</span>
      <textarea
        id={fieldId}
        className={`w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-slate-900 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-500 ${className}`}
        {...props}
      />
    </label>
  )
}

export function Panel({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <h2 className="mb-4 font-display text-lg font-black text-[#0b2ea8] sm:text-xl">{title}</h2>
      {children}
    </section>
  )
}

export function ReadOnlyBanner() {
  return (
    <p className="mb-4 rounded-xl bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-800">
      Conta de autor: pode ver estes dados, mas só consegue cadastrar matérias. Informações sensíveis aparecem mascaradas.
    </p>
  )
}

export function UploadHint({ size, ratio, tip, formats }: { size: string; ratio: string; tip?: string; formats?: string }) {
  return (
    <p className="mt-1.5 rounded-lg bg-slate-50 px-3 py-2 text-xs leading-relaxed text-slate-600">
      Tamanho certo para o upload: <strong className="text-slate-800">{size}</strong> · proporção {ratio}.
      {tip ? ` ${tip}` : ''} {formats || 'Use PNG, JPG ou WEBP.'}
    </p>
  )
}
